import React, { Component } from 'react';

import Uuid from '../../../../../support/Uuid';
import ComercioExteriorDestinatarioForm from './ComercioExteriorDestinatarioForm';
import ComercioExteriorDestinatarioList from './ComercioExteriorDestinatarioList';

class ComercioExteriorDestinatarioManager extends Component {
  state = {};

  componentDidMount() {
    const { Destinatario } = this.props.data;

    if (!Destinatario || Destinatario.length === 0) {
      const { input: { Receptor } } = this.props;

      this.handleOnEdit({
        id: Uuid.v4(),
        Nombre: Receptor.razon_social,
        NumRegIdTrib: Receptor.num_reg_id_trib
      });
    }
  }

  handleOnAdd = (data) => {
    const { Destinatario = [] } = this.props.data;

    const newData = Destinatario.concat([{
      id: Uuid.v4(),
      ...data
    }]);

    this.handleOnListChange(newData);
  }

  handleOnListChange = (data) => {
    const event = { isValid: true, name: 'destinatario' };

    this.props.onChange({
      ...this.props.data,
      Destinatario: data
    }, event);
  }

  handleOnEdit = (item) => {
    this.setState({
      data: { ...item }
    }, () => {
      this.setState({
        data: undefined
      });
    });
  }

  render() {
    const { data } = this.state;
    const { onIgnore } = this.props;
    const { Destinatario = [] } = this.props.data;

    return (
      <div className="pb-4">
        <div>
          <strong className="text-black text-upper">Destinatario</strong>
        </div>

        <div className="section">
          <div className="pt-2">
            <ComercioExteriorDestinatarioForm
              data={ data }
              onAdd={ this.handleOnAdd }
              onIgnore={ onIgnore }
            />
          </div>

          <div className="pt-2">
            <ComercioExteriorDestinatarioList
              data={ Destinatario }
              onEdit={ this.handleOnEdit }
              onChange={ this.handleOnListChange }
            />
          </div>
        </div>
      </div>
    )
  }
}

export default ComercioExteriorDestinatarioManager;